export class PlansSearchModel  {
  search = '';
}

export class TagsSearchModel  {
  selectedTags: Array<any> = [];
}

export class LabelsSearchModel  {
  selectedLabels: Array<any> = [];
}
